import React, { useState } from 'react'
import { useDeleteCompanyMutation, useGetCompaniesQuery } from '../Service/companiesApi';
import { useNavigate } from 'react-router-dom';
import { CompaniesRoutes } from '../../../Router/path';
import CustomCard from '../../Shared/Components/CustomCard/CustomCard';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import ActionButtons from '../../Shared/Components/ActionButtons';
import BusinessIcon from '@mui/icons-material/Business';
import DataTable from '../../Shared/Components/DataTable';
import { companyColumns } from '../columns';
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';
import { useCreateRedirect } from '../../Shared/Hooks/useCreateRedirect';

const Companies = () => {
  const [selectedCompanyIds, setSelectedCompanyIds] = useState<number[]>([]);
  const navigate = useNavigate();

  const { data, isLoading, isError, error } = useGetCompaniesQuery();
  const [deleteCompany] = useDeleteCompanyMutation();

  console.log('Companies data:', data);

  const handleDeleteSelected = useDeleteSelectedItems<number>(
    selectedCompanyIds,
    (id) => deleteCompany(id).unwrap(),
    () => setSelectedCompanyIds([])
  );
  const handleCreate = useCreateRedirect(CompaniesRoutes.create);

  return (
    <>
      <CustomCard
        icon={<BusinessIcon fontSize="large" color="primary" />}
        title="Firmy"
        subheader="Zarządzaj firmami "
        sx={{ mb: 4 }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            Na tej stronie możesz dodawać, edytować i usuwać firmy. Możesz również oznaczać firmy
            jako opublikowane lub nie.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Skorzystaj z przycisków, aby dodać nową firmę lub usunąć wybrane pozycje.
          </Typography>
        </Box>

        <ActionButtons onCreate={handleCreate} onDeleteSelected={handleDeleteSelected} />
      </CustomCard>
      <CustomCard>
        <DataTable
          columns={companyColumns}
          data={data || []}
          isLoading={isLoading}
          isError={isError}
          errorMessage={(error as any)?.data?.message}
          getRowId={(row) => row.id}
          onEdit={(id) => navigate(CompaniesRoutes.update.replace(':companyId', id.toString()))}
          page={0}
          rowsPerPage={10}
          totalCount={data?.length || 0}
          selected={selectedCompanyIds}
          onSelectionChange={setSelectedCompanyIds}
          onPageChange={() => {}}
          onRowsPerPageChange={() => {}}
          editingRowId={null}
          setEditingRowId={() => {}}
        />
      </CustomCard>
    </>
  );
};

export default Companies